import { format } from 'date-fns';

// Format the date as an ISO string without converting to UTC
export const formatDateToISO = ({ date }: { date: Date }): string => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
};
